<template>
  <b-row>
    <b-col cols="8">
      <b-form @submit.prevent="send()">
        <div class="form-group">
          <label for>Camión:</label>
          <div class="col-sm-5">
            <label for>{{ot.incident ? ot.incident.truck.plate : ot.truck.plate}}</label>
          </div>
        </div>
        <div v-if="!isPrev || incident_id" class="form-group">
          <label for>Conductor:</label>
          <div class="col-sm-5">
            <label
              for
            >{{ot.incident.driver ? `${ot.incident.driver.name} ${ot.incident.driver.last_name}` : '-'}}</label>
          </div>
        </div>
        <div v-if="isPrev && ot_id" class="form-group">
          <label for>Tipo Mantención:</label>
          <div v-if="ot.plan.type" class="col-sm-5">
            <label for>Tipo {{ot.plan.type.name}}: {{ot.plan.type.description}}</label>
          </div>
        </div>
        <div v-if="isPlanner" class="form-group">
          <label for>Fecha inicial</label>
          <div class="col-sm-5">
            <date-picker
              v-model="ot.initial_date"
              required
              lang="es"
              type="date"
              format="DD/MM/YYYY"
            ></date-picker>
          </div>
        </div>
        <div v-if="isPlanner" class="form-group">
          <label for>Fecha final</label>
          <div class="col-sm-5">
            <date-picker v-model="ot.final_date" required lang="es" type="date" format="DD/MM/YYYY"></date-picker>
          </div>
        </div>
        <div v-if="!isPlanner && ot_id" class="form-group">
          <label for>Mecánico</label>
          <div class="col-sm-12">
            <select v-model="ot.mech_id" class="form-control" required>
              <option
                v-for="(mechanic, k) in mechanics"
                :key="k"
                :value="mechanic.id"
              >{{mechanic.name}}</option>
            </select>
          </div>
        </div>
        <div v-if="!isPlanner && ot_id" class="form-group">
          <label for>Estado</label>
          <div class="col-sm-12">
            <select @change="onChange" v-model="ot.status_id" class="form-control">
              <option value>Seleccione Estado</option>
              <option v-for="(status,k) in statuses" :key="k" :value="status.id">{{status.name}}</option>
            </select>
          </div>
        </div>
        <div v-if="incident_id || !isPrev" class="form-group">
          <div class="table-responsive tableFixHead">
            <table class="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th>Formulario de conductor</th>
                  <th>OK?</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item,k) in driverItems"
                  :key="k"
                  href="#"
                  active
                  class="flex-column align-items-start"
                >
                  <td>{{item.name}}</td>
                  <td>
                    <span v-if="item._pivot_answer" class="badge badge-pill badge-success">Si</span>
                    <span v-else class="badge badge-pill badge-danger">No</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="ot_id && !isPrev" class="form-group">
          <div class="table-responsive tableFixHead">
            <table class="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th>Formulario de mecánico</th>
                  <th>Respuesta</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item,k) in mechItems"
                  :key="k"
                  href="#"
                  active
                  class="flex-column align-items-start"
                >
                  <td>{{item.name}}</td>
                  <td>
                    <span v-if="item._pivot_answer" class="badge badge-pill badge-success">Si</span>
                    <span v-else class="badge badge-pill badge-danger">No</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="incident_id" class="form-group">
          <div class="table-responsive tableFixHead">
            <table class="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th>Formulario de mecánico</th>
                  <th>SI</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item,k) in items"
                  :key="k"
                  href="#"
                  active
                  class="flex-column align-items-start"
                >
                  <td>{{item.name}}</td>
                  <td>
                    <input @change="check(k)" type="checkbox" :checked="item.answer" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="form-group">
          <label for>Comentarios Mecánico</label>
          <div class="col-sm-12">
            <textarea v-if="!isPlanner" class="form-control" v-model="ot.comments" rows="3"></textarea>
            <p v-else>{{ot.comments}}</p>
          </div>
        </div>
        <div v-if="ot_id" class="form-group">
          <label for>Repuestos</label>
          <table class="table table-bordered table-hover table-striped">
            <thead>
              <tr>
                <th>Cantidad</th>
                <th>Unidad</th>
                <th>Descripción de Repuesto</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(rep, k) in ot.replacements" :key="k">
                <td>{{rep.quantity}}</td>
                <td>{{rep.unit ? rep.unit.name : "-"}}</td>
                <td>{{rep.description}}</td>
                <td>
                  <button @click="removeReplacement(rep.id)" type="button" class="btn btn-danger">
                    <i class="fa-minus fa font-2xl d-block"></i>
                  </button>
                </td>
              </tr>
              <tr>
                <td>
                  <input type="number" class="form-control" v-model="replacement.quantity" />
                </td>
                <td>
                  <select v-model="replacement.unit" class="form-control">
                    <option v-for="(unit, k) in units" :key="k" :value="unit.id">{{unit.name}}</option>
                  </select>
                </td>
                <td>
                  <input type="text" class="form-control" v-model="replacement.description" />
                </td>
                <td>
                  <button @click="addReplacement()" type="button" class="btn btn-primary">
                    <i class="fa-plus fa font-2xl d-block"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="!isFinished" class="form-group">
          <input type="submit" value="Enviar" class="btn btn-primary" />
        </div>
      </b-form>
    </b-col>
  </b-row>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  props: ["ot_id", "incident_id"],
  data() {
    return {
      ot: {
        incident: null,
        comments: "",
        final_date: null,
        initial_date: null,
        truck: {},
        plan: {},
        status: {}
      },
      status_id: null,
      quickFix: false,
      constants,
      approved: false,
      driverItems: [],
      mechItems: [],
      items: [],
      statuses: [],
      mechanics: [],
      isPlanner: false,
      isPrev: true,
      isFinished: false,
      replacement: {},
      units: []
    };
  },
  mounted() {
    api.get("/work_order_statuses").then(res => {
      this.statuses = res.statuses;
    });
    api.get("/units").then(res => {
      this.units = res.units;
    });
    api.get("/mechanics").then(res => {
      this.mechanics = res.mechanics;
    });
    if (this.ot_id) {
      api.get(`/work_order/${this.ot_id}`).then(response => {
        this.ot = response.ot;
        this.isFinished = this.ot.status.code === constants.MANT_FINALIZADO;
        this.isPrev = this.ot.type.code === constants.PREVENTIVA;
        if (!this.isPrev)
          api.get(`/roles`).then(res => {
            const driver = res.roles.find(
              role => role.code === constants.CONDUCTOR
            );
            const items = response.ot.incident.items;
            this.driverItems = items.filter(it => it.role_id === driver.id);
            this.mechItems = items.filter(it => it.role_id !== driver.id);
          });
        this.approved = response.ot.approved;
      });
    }
    if (this.incident_id) {
      this.isPrev = false;
      api.get(`/incident/${this.incident_id}`).then(response => {
        api.get(`items/${response.incident.truck.type}`).then(res => {
          const items = res.items.map(it => ({ ...it, answer: true }));
          this.items = items;
        });
        this.ot.incident = response.incident;
        this.ot.incident_id = response.incident.id;
        this.driverItems = response.incident.items;
      });
    }
    this.isPlanner =
      this.user.role.code === constants.PLANIFICADOR_MANTENIMIENTO;
  },
  computed: {
    ...mapGetters({ user: "user/user" })
  },
  methods: {
    removeReplacement(id) {
      api
        .delete(`/replacement/${id}`)
        .then(response => {
          if (response.success) {
            let index = this.ot.replacements.findIndex(rq => rq.id === id);
            if (index >= 0) {
              this.ot.replacements.splice(index, 1);
            }
            this.showSuccess("Repuesto Eliminado");
          }
        })
        .catch(err => console.log(err));
    },
    addReplacement() {
      const { quantity, description, unit } = this.replacement;
      if (!quantity || !description || !unit) {
        this.showError("Debe completar todos los campos");
        return;
      }
      api
        .post("/replacement", {
          ...this.replacement,
          work_order_id: this.ot_id
        })
        .then(response => {
          if (response.success) {
            this.ot.replacements.push(response.replacement);
            this.replacement = {};
            this.showSuccess("Repuesto agregado");
          }
        })
        .catch(err => console.log(err));
    },
    onChange(ev) {
      this.status_id = ev.target.value;
    },
    check(index) {
      this.items[index].answer = !this.items[index].answer;
    },
    showSuccess(label) {
      this.$toastr.success(label, "Operación exitosa", {
        positionClass: "toast-top-center",
        closeButton: true
      });
    },
    showError(label) {
      this.$toastr.error(label, "Error", {
        positionClass: "toast-top-center",
        closeButton: true
      });
    },
    setDatetime(date) {
      return date ? moment(date).format("YYYY-MM-DD 23:59:59") : null;
    },
    send() {
      let { ot_id, incident_id, ot, user, approved, items, status_id } = this;
      let data = {};

      const initial_date = this.setDatetime(ot.initial_date);
      const final_date = this.setDatetime(ot.final_date);

      data = {
        initial_date,
        final_date,
        mech_id: ot.mech_id
      };
      if (ot_id) {
        if (status_id) data = { ...data, status_id: parseInt(status_id) };
        if (user.role.code === constants.MECANICO)
          data = { ...data, comments: ot.comments };
        api.put(`/work_order/${ot_id}`, data).then(response => {
          this.$socket.emit("updateIncidentServer", response.ot);
          this.showSuccess("Orden de trabajo actualizado");
        });
      }
      if (incident_id) {
        data = {
          incident_id,
          comments: ot.comments,
          initial_date,
          final_date,
          items: items.map(it => ({ id: it.id, answer: it.answer }))
        };
        api
          .post("/work_order", data)
          .then(response => {
            if (response.success) {
              this.$socket.emit("newWorkOrderServer", response.ot);
              this.showSuccess("Orden de trabajo creada");
            }
          })
          .catch(err => console.log(err));
      }
    }
  }
};
</script>
